import axios from 'axios'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class RegistryRequestPrintService {
    async getRequestReport(laboratoryId, requestIds, encoded) {
        const config = {
            params: { listReqIds: requestIds.join(','), encoded },
            headers: { type: 'application/pdf' },
            responseType: encoded ? 'text' : 'arraybuffer'
        }
        const response = await axios.get(`/registry/laboratories/${laboratoryId}/requests/reports`, config)
        return response.data
    }

    async exportTo(laboratoryId, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return axios.put(
            `registry/laboratories/${laboratoryId}/requests/reportRequestsGrid`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
}
export const registryRequestPrintService = new RegistryRequestPrintService()
